<template>
  <pt-goods-manage class="pt-goods-manage__page"></pt-goods-manage>
</template>

<script>
import PtGoodsManage from 'cps/mall-manage/pt-goods-manage/withData'
export default {
  name: 'pt-goods-manage__view',
  components: {
    'pt-goods-manage': PtGoodsManage
  }
}
</script>
